import React from 'react';
import { Modal } from 'antd';
import styles from './styles.less';

export const ComponentModal = (props) => {
  const { onSubmit, onCancel, visible } = props;
  return (
    <Modal
      wrapClassName={styles.componentModal}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      {React.cloneElement(props.children, { modal: true, onSubmit, onCancel })}
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/ComponentModal/ComponentModal.js